import React, { Component } from 'react';
import { connect } from 'react-redux';
import { showBlocker, hideBlocker } from '../../actions/blocker';
import { fetchFlightDocuments, saveFlightDocument, updateFlightDocument, deleteFlightDocument, download, generateEff, emailEff } from '../../actions/flight-list';
import MimeIcon from '../mime-icon/mime-icon';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFileUpload, faCog, faEnvelope, faTrash } from '@fortawesome/free-solid-svg-icons';
import $ from 'jquery';

const CLASSIFICATIONS = ['NOTAM', 'MET', 'MEL', 'ADDL', 'CFP']

class Documents extends Component {
    constructor(props) {
        super(props);
        this.state = {
            data: [],
            emailSuccessAlert: false,
            emailFailAlert: false,
            emailNotFoundAlert: false,
        }
        this.fileSelector = document.createElement('input');
        this.fileSelector.setAttribute('type', 'file');
        this.fileSelector.setAttribute('multiple', 'multiple');
        this.fileSelector.addEventListener('change', e => this.saveFiles(e));
        this.saveFiles = this.saveFiles.bind(this);
        this.generateEff = this.generateEff.bind(this);
        this.emailEff = this.emailEff.bind(this);
        this.showAlert = this.showAlert.bind(this);
        this.failAlert = this.failAlert.bind(this);
        this.notFoundAlert = this.notFoundAlert.bind(this);
    }

    componentDidMount() {
        this.props.setDocs();
    }

    saveFiles(e) {
        e.preventDefault();
        this.props.showBlocker();
        const files = e.currentTarget.files;
        const promises = [];
        for (let i = 0; i < files.length; i++) {
            promises.push(this.props.saveFlightDocument(this.props.id, files.item(i)));
        }
        $.when.apply($, promises).always(_ => {
            this.props.setDocs();
            this.props.hideBlocker();
        });
    }

    generateEff(e) {
        e.preventDefault();
        this.props.showBlocker();
        this.isGenerateEff = true;
        this.props.generateEff(this.props.id)
            .done(this.props.setDocs)
            .fail()
            .always(_ => {
                this.isGenerateEff = false;
                this.props.hideBlocker();
            });
    }

    emailEff(e) {
        e.preventDefault();
        this.props.showBlocker();
        this.sendingEmail = true;
        let selected = this.props.selected;
        let options = {
            flt: selected.flt,
            reg: selected.reg,
            dep: selected.dep,
            arr: selected.arr,
            std: selected.std,
            etd: selected.etd,
            capName: selected.capName,
            foName:selected.foName,
            capEcn :selected.cap,
            foEcn:selected.fo
        }
        this.props.emailEff(this.props.id, options)
            .done(res => {
                if(res.status == 200){
                this.setState({ emailSuccessAlert: true })
                }
                else if (res.status == 404){
                    this.setState({emailNotFoundAlert: true})
                }
                else{
                    this.setState({ emailFailAlert: true })
                }
            })
            .fail()
            .always(_ => {
                this.sendingEmail = false;
                this.props.hideBlocker();
            });
    }

    showAlert() {
        return (
            <div className='text-center col-md-3' style={{margin: "auto"}}>
                <div className="alert alert-sm alert-success alert-dismissible fade show" role="alert">
                    <strong>Email sent successfully</strong>
                    <button type="button" class="close" data-dismiss="alert" aria-label="Close"
                        onClick={() => { this.setState({ emailSuccessAlert: false }) }}
                    >
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
            </div>
        )
    }

    failAlert() {
        return (
            <div className='text-center col-md-3' style={{margin: "auto"}}>
                <div className="alert alert-sm alert-success alert-dismissible fade show" role="alert">
                    <strong>Email not sent</strong>
                    <button type="button" class="close" data-dismiss="alert" aria-label="Close"
                        onClick={() => { this.setState({ emailFailAlert: false }) }}
                    >
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
            </div>
        )
    }

    notFoundAlert() {
        return (
            <div className='text-center col-md-3' style={{margin: "auto"}}>
                <div className="alert alert-sm alert-success alert-dismissible fade show" role="alert">
                    <strong>Email not Found</strong>
                    <button type="button" class="close" data-dismiss="alert" aria-label="Close"
                        onClick={() => { this.setState({ emailNotFoundAlert: false }) }}
                    >
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
            </div>
        )
    }

    render() {
        let data = [...this.props.data].sort(({ classification: c1 }, { classification: c2 }) => {
            if (c1 === c2) return 0;
            if (c1 === 'EFF' || (c1 === 'BRIEFING_SHEET' && c2 !== 'EFF')) return -1;
            if (c2 === 'EFF' || c2 === 'BRIEFING_SHEET') return 1;
            return 0;
        });

        const rows = data.map(d => <Document key={d.id}
            data={d}
            onChange={this.onChange}
            updateFlightDocument={this.props.updateFlightDocument}
            deleteFlightDocument={this.props.deleteFlightDocument}
            showBlocker={this.props.showBlocker}
            hideBlocker={this.props.hideBlocker}
            download={this.props.download} />)

        return (
            <>
                { (this.state.emailSuccessAlert) && <this.showAlert />}
                { (this.state.emailFailAlert) && <this.failAlert />}
                { this.state.emailNotFoundAlert ? <this.notFoundAlert /> : <></>}

                <div className='d-flex' style={{ backgroundColor: '#425573' }}>
                    <button className='btn btn-light py-0 d-flex align-items-center'
                        onClick={_ => this.fileSelector.click()}>
                        <i style={{ fontSize: '1.5rem' }}><FontAwesomeIcon icon={faFileUpload} /></i>
                        <span className='small ml-1'>Upload</span>
                    </button>
                    <button className='btn btn-light py-0 d-flex align-items-center border-left border-dark'
                        onClick={this.generateEff}
                        disabled={this.isGenerateEff}>
                        <i style={{ fontSize: '1.5rem' }}><FontAwesomeIcon icon={faCog} /></i>
                        <span className='small ml-1'>Generate EFF</span>
                    </button>
                    <button className='btn btn-light py-0 d-flex align-items-center border-left border-dark'
                        onClick={this.emailEff}
                        disabled={this.sendingEmail || !data.find(d => d.classification === 'EFF')}>
                        <i style={{ fontSize: '1.5rem' }}><FontAwesomeIcon icon={faEnvelope} /></i>
                        <span className='small ml-1'>Email EFF to <span className='font-weight-bold'>{this.props.options.dep}</span> Airport</span>
                    </button>
                </div>
                <table className='table table-sm text-light m-0 table-fixed'>
                    <thead>
                        <tr className='text-nowrap'>
                            <th className='text-center' style={{ width: '2.5rem' }}></th>
                            <th className='text-left' style={{ width: '50%' }}>Name</th>
                            <th className='text-left' style={{ width: '8rem' }}>Classification</th>
                            <th className='text-center' style={{ width: '8rem' }}>Include</th>
                            <th className='text-right' style={{ width: '8rem' }}>Size (KB)</th>
                            <th className='text-center'>Created (yyyy-mm-dd)</th>
                            <th className='text-right'>Created by</th>
                            <th className='text-center' style={{ width: '3rem' }}></th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            rows.length ? rows :
                                <tr>
                                    <td className='text-center font-weight-light font-italic h6'
                                        colSpan='100%'>No documents found.</td>
                                </tr>
                        }
                    </tbody>
                </table>
            </>
        )
    }
};

class Document extends Component {
    constructor(props) {
        super(props);
        let { classification, include } = this.props.data;
        this.state = {
            classification,
            include,
        };
        this.onChange = this.onChange.bind(this);
        this.onDelete = this.onDelete.bind(this);
    }

    onChange(e, field) {
        let change = {};
        switch (field) {
            case 'classification':
                change.classification = e.currentTarget.value;
                break;
            case 'include':
                change.include = e.currentTarget.checked;
                break;
            default:
                break;
        };
        this.props.showBlocker();
        this.props.updateFlightDocument(this.props.data.id, { ...this.props.data, ...change })
            .done(_ => this.setState(change))
            .always(this.props.hideBlocker);
    }

    onDelete() {
        this.props.showBlocker();
        this.props.deleteFlightDocument(this.props.data.id)
            .done(_ => this.setState({ delete: true }))
            .always(this.props.hideBlocker);
    }

    render() {
        const { id, mime, name, size, created, creator } = this.props.data;
        return this.state.delete ? null : <tr>
            <td className='align-middle text-center text-nowrap'><MimeIcon mime={mime} /></td>
            <td className='align-middle text-left'>
                <button className='btn btn-link text-light text-left'
                    onClick={e => this.props.download(id)}>{name}</button>
            </td>
            <td className='align-middle text-left'>
                {
                    this.state.classification === 'EFF' || this.state.classification === 'BRIEFING_SHEET' ?
                        this.state.classification :
                        <select className='form-control text-light bg-transparent rounded-0 py-0 pl-0 h-auto'
                            value={this.state.classification || 'NONE'}
                            onChange={e => this.onChange(e, 'classification')}>
                            <option className='text-dark'>NONE</option>
                            {CLASSIFICATIONS.map(c => <option key={c} className='text-dark'>{c}</option>)}
                        </select>
                }
            </td>
            <td className='align-middle text-center'>
                {
                    this.state.classification === 'EFF' ? null :
                        <div className='custom-control custom-switch'>
                            <input className='custom-control-input'
                                id={id}
                                type='checkbox'
                                onChange={e => this.onChange(e, 'include')}
                                checked={this.state.include} />
                            <label className='custom-control-label'
                                htmlFor={id}></label>
                        </div>

                }
            </td>
            <td className='align-middle text-right text-nowrap'>{size}</td>
            <td className='align-middle text-center'>{created}</td>
            <td className='align-middle text-right'>{creator}</td>
            <td className='align-middle text-center'>
                {
                    this.state.classification !== 'EFF' &&
                    <i className='cursor-pointer'
                        onClick={() => {
                            if (window.confirm("Are you sure you want to delete this document?")) {
                                this.onDelete()
                            }
                        }}><FontAwesomeIcon icon={faTrash} /></i>
                }
            </td>
        </tr>;
    }
};

const mapStateToProps = state => ({
    selected: state.flights.selected
});

const mapActionsToProps = {
    showBlocker, hideBlocker,
    fetchFlightDocuments, saveFlightDocument, updateFlightDocument, deleteFlightDocument, download, generateEff, emailEff,
};

export default connect(mapStateToProps, mapActionsToProps)(Documents);